/**
 * The user's chosen LoRa network profile and any custom ones.
 *
 * Per-device convenience state, so localStorage is the right home; every
 * access is guarded because storage can be missing or throw (private mode,
 * blocked site data), and the app must work without it.
 */

import { DEFAULT_PROFILE_ID, type LoRaNetworkProfile } from '../lora/profiles'

const SELECTED_KEY = 'crowdtalkie-lora-profile'
const CUSTOM_KEY = 'crowdtalkie-lora-custom-profiles'

export function getSelectedProfileId(): string {
  try {
    return localStorage.getItem(SELECTED_KEY) ?? DEFAULT_PROFILE_ID
  } catch {
    return DEFAULT_PROFILE_ID
  }
}

export function setSelectedProfileId(id: string): void {
  try {
    localStorage.setItem(SELECTED_KEY, id)
  } catch {
    // not persisted; the choice still applies for this session
  }
}

export function getCustomProfiles(): LoRaNetworkProfile[] {
  try {
    const raw = localStorage.getItem(CUSTOM_KEY)
    const parsed: unknown = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? (parsed as LoRaNetworkProfile[]) : []
  } catch {
    return []
  }
}

export function saveCustomProfile(profile: LoRaNetworkProfile): LoRaNetworkProfile[] {
  const list = [...getCustomProfiles().filter((p) => p.id !== profile.id), profile]
  try {
    localStorage.setItem(CUSTOM_KEY, JSON.stringify(list))
  } catch {
    // keep going with the in-memory list
  }
  return list
}
